module.exports = {"backgroundImage":"manage-voice-interactions.png","components":[]}


//////////////////
// WEBPACK FOOTER
// ./src/data/scenes/manage-voice-interactions.json
// module id = 601
// module chunks = 0